import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DconSharedService } from './dcon-shared.service';
import { DataService } from './data.service';

@Component({
    selector: 'dcon-folder-details',
    template: '',
})

export class DconFolderDetailsComponent implements OnInit {
    public tokenValue: any;
    public assetFoldId: any;
    constructor(private _https: HttpClient,
        private sharedServiceData: DconSharedService,
        private _data: DataService,) {
    }
    ngOnInit() {
        setTimeout(() => {
            this._data.assetFolderId.subscribe((res) => {
                this.assetFoldId = res?.value[0].Id;
            });

            this._data.token.subscribe((res) => {
                this.tokenValue = res;
            });
            //   this.assetFolderName();
        }, 10000);
    }

    // ******************************************************
    // This method is on hold,
    // ******************************************************
    assetFolderName() {
        const httpOptions = {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + this.tokenValue,
                'X-UIPATH-TenantName': 'DFTEQA',//config.ts
                'X-UIPATH-OrganizationUnitId': this.assetFoldId
            })
        };
        const url = "https://qa-uipath-oracleofferingdfte.deloitte.com/odata/Assets?$filter=Name eq 'DCODE_BOT_RETRIES'";//config.ts

        this._https.get(url, httpOptions).subscribe(res => {
            console.log('###Nithin', res);
        });
        /*  this.sharedServiceData.callProjectUrlAssetFetch(httpOptions).subscribe(res=>{
             console.log('$$$$###%%%', res)
         }) */
    }
}
